<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      描述：设置-交易设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">订单流程设置</div>
      <el-form-item label="未支付订单">
        <el-input v-model="form.close_days" type="number" style="width: 200px;"></el-input>
        分钟后自动关闭
        <div class="tips">
          订单下单未付款，n分钟后自动关闭，设置0不自动关闭
        </div>
      </el-form-item>
      <el-form-item label="已发货订单">
        <el-input v-model="form.receive_days" type="number" style="width: 200px;"></el-input>
        天后自动确认收货
        <div class="tips">
          如果在期间未确认收货，系统自动完成收货，设置0天不自动收货
        </div>
      </el-form-item>
      <el-form-item label="已完成订单">
        <el-input v-model="form.refund_days" type="number" style="width: 200px;"></el-input>
        天内允许申请售后
        <div class="tips">
          订单完成后 ，用户在n天内可以发起售后申请，设置0天不允许申请售后
        </div>
      </el-form-item>
      <el-form-item label="小程序发货信息管理"  v-auth="'/appsetting/appwx/index'">
       <div>
         <el-radio v-model="form.open_wx_shipping" :label="10">开启</el-radio>

         <el-radio v-model="form.open_wx_shipping" :label="0">关闭</el-radio>
        <div class="gray9">确保微信小程序有开启该功能再开启，开启后，【设置】->【物流公司】中需要添加微信平台的物流公司代码</div>
       </div>
      </el-form-item>


      <div class="common-form">运费设置</div>
      <el-form-item label="运费组合策略">
        <div>
          <el-radio v-model="form.freight_rule" :label="10">叠加</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，将每个商品的运费之和订为订单总运费
          </div>

        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freight_rule" :label="20">已低运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最少的商品的运费计为订单总运费
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-radio v-model="form.freight_rule" :label="30">已高运费结算</el-radio>
          <div class="tips">
            订单中的商品有多个运费模板时，取订单中运费最多的商品的运费计为订单总运费
          </div>
        </div>
      </el-form-item>

      <div class="common-form">商品购买权限</div>
      <el-form-item label="选择购买等级">
        <el-checkbox-group v-model="form.product_buy_limit">
          <el-checkbox v-for="(item,index) in gradeList" :key="index" :label="item.grade_id" >{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="gray9">选中的等级用户才能购买商品,全部未选择则不生效</div>
        <div class="gray9">注：如果单个商品中也有设置购买权限,以商品设置优先</div>
      </el-form-item>
      <el-form-item label="下单需要同意协议">
        <el-radio v-model="form.need_agreement" :label="10">否</el-radio>
        <el-radio v-model="form.need_agreement" :label="20">是</el-radio>
      </el-form-item>

      <div class="common-form">支付设置</div>
      <el-form-item label="选择支付方式">
        <el-checkbox-group v-model="form.pay_type">
          <el-checkbox v-for="(item,index) in list" :key="index" :label="item.id" >{{item.name}}</el-checkbox>
        </el-checkbox-group>

      </el-form-item>
      <el-form-item label="佣金支付文案" v-auth="'/plus/agent/setting/commissionpay'">
        <el-input v-model="form.agent_money_text" type="text" placeholder="佣金支付" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="是否开启随机立减">
       <div>
         <el-radio v-model="form.random_reduce" :label="1">开启</el-radio>
         <el-radio v-model="form.random_reduce" :label="0">关闭</el-radio>
          <div class="gray9">开启后每单将在随机立减区间内随机减价</div>
       </div>
      </el-form-item>
      <el-form-item label="随机立减区间:" v-if="form.random_reduce == 1">
        <span class="ml10">最小值 </span>
        <el-input v-model="form.min_random_reduce_money" placeholder="最小值" type="number" min="0" style="width: 100px;"></el-input>
        <span class="ml10">元  最大值 </span>
        <el-input v-model="form.max_random_reduce_money" placeholder="最大值" type="number" min="0" style="width: 100px;"></el-input>
        <span class="ml10">元</span>
      </el-form-item>
      <el-form-item label="是否开启新用户首购折扣">
       <div>
         <el-radio v-model="form.open_first_purchase_discount" :label="1">开启</el-radio>
         <el-radio v-model="form.open_first_purchase_discount" :label="0">关闭</el-radio>
         <div class="gray9">开启后，新用户首次注册购买时商品售价=原价*新用户首购折扣</div>
       </div>
      </el-form-item>
      <el-form-item label="新用户首购折扣" v-if="form.open_first_purchase_discount == 1">
        <el-input v-model="form.first_purchase_discount" type="number" min="0" max="100" style="width: 200px;"></el-input>
        <span class="ml10">%</span>
      </el-form-item>
      <el-form-item label="付款凭证支付账户">
        <el-input v-model="form.pay_image_number" type="text"  style="width: 200px;"></el-input>

      </el-form-item>
      <el-form-item  label="付款凭证支付收款码图片" >
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.pay_image_qrcode" width="200">
      </el-form-item>
      <div class="common-form">售后设置</div>
      <el-form-item label="是否开启售后">
       <div>
         <el-radio v-model="form.after_sale" :label="10">开启</el-radio>

         <el-radio v-model="form.after_sale" :label="20">关闭</el-radio>

       </div>
      </el-form-item>

      <div class="common-form">评价设置</div>
      <el-form-item label="是否开启评价">
       <div>
         <el-radio v-model="form.open_evaluation" :label="10">开启</el-radio>

         <el-radio v-model="form.open_evaluation" :label="20">关闭</el-radio>

       </div>
      </el-form-item>

      <div class="common-form">提现密码</div>
      <el-form-item label="提现类型">
       <div>
         <el-radio v-model="form.withdraw_type" :label="10">新版本</el-radio>

         <el-radio v-model="form.withdraw_type" :label="20">老版本</el-radio>
          <div class="tips">
            注：老版本使用 企业付款到零钱，新版本使用商家转账到零钱，请结合商户号的权限选择
          </div>
       </div>
      </el-form-item>
      <el-form-item label="原密码">
        <el-input v-model="form.old_password" type="text" style="width: 200px;"></el-input>
        <div class="tips">
          注：如不修改则保留空,首次输入提现密码无需输入原密码
        </div>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.new_password" type="text" style="width: 200px;"></el-input>
        <div class="tips">
          注：如不修改则保留空
        </div>

      </el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  export default {
    components:{
      Upload,

    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          close_days: '',
          receive_days: '',
          refund_days: '',
          freight_rule: '',
          pay_type:[],
          after_sale:10,
          random_reduce:0,
          open_evaluation:10,
          min_random_reduce_money:0,
          max_random_reduce_money:0,
          open_first_purchase_discount: '0',
          first_purchase_discount: '0',
          agent_money_text: '',
          //商品购买限制
          product_buy_limit:[],
          old_password: '',
          new_password: '',
          withdraw_type:10,
          need_agreement:10,
          pay_image_number:'',
          pay_image_qrcode:'',
          open_wx_shipping:0,
        },
        loading: false,
        list: [],
        gradeList:[],
        isupload:false,
      };
    },
    created() {
      this.getParams()
    },

    methods: {
      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.form.pay_image_qrcode=e[0].file_path;
      },
      getParams() {
        let self = this;
        SettingApi.tradeDetail({}, true)
          .then(data => {
            if (data.code == 1) {
              let vars = data.data.vars.values;
              self.form.close_days = vars.order.close_days;
              self.form.receive_days = vars.order.receive_days;
              self.form.refund_days = vars.order.refund_days;
              self.form.freight_rule = vars.freight_rule;
              self.form.after_sale = vars.after_sale;
              self.form.random_reduce = vars.random_reduce;
              self.form.open_evaluation = vars.open_evaluation;
              self.form.min_random_reduce_money = vars.min_random_reduce_money;
              self.form.max_random_reduce_money = vars.max_random_reduce_money;
              self.form.open_first_purchase_discount = vars.open_first_purchase_discount;
              self.form.first_purchase_discount = vars.first_purchase_discount;
              self.form.withdraw_type = vars.withdraw_type;
              self.form.need_agreement = vars.need_agreement;
              self.form.agent_money_text = vars.agent_money_text;
              self.form.pay_image_qrcode = vars.pay_image_qrcode;
              self.form.pay_image_number = vars.pay_image_number;
              self.form.open_wx_shipping = vars.open_wx_shipping;
              //商品购买限制
              if(vars.product_buy_limit){
                self.form.product_buy_limit = vars.product_buy_limit;
              }else{
                self.form.product_buy_limit = [];
              }
              if(vars.pay_type){
                self.form.pay_type = vars.pay_type;
              }else{
                self.form.pay_type = [];
              }
              self.list = data.data.pay_type;
              //会员等级列表
              self.gradeList = data.data.gradeList;
            }
          })
          .catch(error => {

          });

      },
      //监听复选框选中
      handleCheckedCitiesChange(val) {},
      onSubmit() {
        let self = this;
        self.loading = true;
        let form = self.form;
        if (form.pay_type.length == 0) {
          self.$message({
              message: '请选择支付方式',
              type: 'error'
            });
            self.loading = false;
            return false;
        }

        if (form.random_reduce == 1 && form.min_random_reduce_money >= form.max_random_reduce_money) {
          self.$message({
              message: '随机立减区间最大值应大于最小值',
              type: 'error'
            });
            self.loading = false;
            return false;
        }

        SettingApi.editTrade(form, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，交易设置成功',
              type: 'success'
            });
            self.$router.push('/setting/trade/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },


    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/trade/index.vue